import auth from '@app/Middlewares/Auth';

export default [
  {
    url: '/species',
    page: 'species/Index',
    name: 'species',
    meta: {
      label: 'Dashboard',
      layout: 'Dashboard',
      middleware: [auth],
      role: {
        only: ['tourism-operator', 'admin'],
      },
    },
    group: [
      {
        url: '/species/create',
        page: 'species/Create',
        name: 'new-species',
        role: {
          only: 'admin',
        },
        group: [
          {
            url: '/species-families',
            page: 'species/families/Index',
            name: 'species-family',
          },
          {
            url: '/species-families/create',
            page: 'species/families/Create',
            name: 'new-species-family',
          },
          {
            url: '/species-families/:id',
            page: 'species/families/Create',
            name: 'edit-species-family',
          },
          {
            url: '/species/:id',
            page: 'species/Create',
            name: 'edit-species',
          },
        ],
      },
    ],
  },
];
